var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.725 14.999C16.5167 14.4073 17.1667 13.1156 17.1667 12.1323V5.94064C17.1667 4.91564 16.3833 3.78229 15.425 3.42395L11.2667 1.86563C10.575 1.60729 9.44167 1.60729 8.75 1.86563L4.59168 3.42395C3.63334 3.78229 2.85001 4.91564 2.85001 5.94064V12.1323C2.85001 13.1156 3.5 14.4073 4.29166 14.999L7.87501 17.674C9.05001 18.5573 10.9833 18.5573 12.1583 17.674L12.775 17.2073",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.10132C9.96667 9.10132 9.925 9.10132 9.89166 9.10132C9.10833 9.07632 8.48333 8.42631 8.48333 7.63464C8.48333 6.82631 9.14167 6.16797 9.95 6.16797C10.7583 6.16797 11.4167 6.82631 11.4167 7.63464C11.4083 8.43464 10.7833 9.07632 10 9.10132Z",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34167 11.4328C7.54167 11.9661 7.54167 12.8411 8.34167 13.3745C9.25001 13.9828 10.7417 13.9828 11.65 13.3745C12.45 12.8411 12.45 11.9661 11.65 11.4328C10.75 10.8245 9.25834 10.8245 8.34167 11.4328Z",
    stroke: "#1A6D73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRoles);
export default __webpack_public_path__ + "static/media/activeRoles.c9bda6a1143ee9306b9a783f6808c5f8.svg";
export { ForwardRef as ReactComponent };